import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import routes from "./routes";
import "./styles/app.scss";
import ModalWrapper from "./components/ModalWrapper";
import {AppContextProvider} from "./contexts/AppContext";
import AppContext from "./contexts/AppContext";
import {hitEvent, hits, logEvent, userEvents} from "./utils/log";
import * as webviewUtils from "./utils/webview";
import ErrorBoundary from "./components/ErrorBoundary";
import WindowSizeWatcher from "./components/WindowSizeWatcher";
import RouteChangeListener from "./components/RouteChangeListener";
import AppToast from "./components/AppToast";
import {withRouter} from "react-router";
import IndexPage from "./pages/index/IndexPage";
import ProcessingPage from "./pages/processing/ProcessingPage";
import ResultPage from "./pages/result/ResultPage";
import inappsHelper from "./helpers/inapps.helper";
import PhotochooserPage from "./pages/photochooser/PhotochooserPage";
import clientStorage from "./utils/client-storage";
import ComparatorPage from "./pages/comparator/ComparatorPage";
import {signalEvent, signals} from "./utils/signals";
import {calculateViewport} from "./utils/etc";
import TestInstanceIndicator from "./components/TestInstanceIndicator";

window.onerror = function (message, file, line, col, error) {
  hitEvent(hits.jsGlobalError, 1, true, 0);
  signalEvent(signals.jsGlobalError, 1, true);
  logEvent(userEvents.JS_GLOBAL_ERROR, {
    message,
    file,
    line,
    col,
    error: error.message,
    url: window.location.href,
  }, null, true);
};

class App extends React.Component {

  state = {
    isReady: window.clientConfig.isWeb,
  };

  componentDidMount() {
    window.webviewEventsListeners.setPrice.subscribe((data) => {
      this.context.setSkus(data || {});
    }, true);

    window.webviewEventsListeners.tabSelected.subscribe((v) => {
      v && this.handleWebviewTabSelected();
    }, true);

    if (window.clientConfig.isWebview) {
      // inappsHelper.setUserClientData(window.clientConfig.webviewParams);
      // inappsHelper.fetchList().then((res) => {
      //   this.checkAwaitingBilledSku(res.data);
      //   this.context.setPurchases(res.data, () => {
      //     this.setState({isReady: true});
      //   });
      // }).catch((err) => {
      //   console.error(err);
      //   this.setState({isReady: true});
      // });

      this.setState({isReady: true});

      webviewUtils.webviewOnPageFinished();
    }

    window.clientConfig.platform.os.toLowerCase() === "ios" && document.body.classList.add("ios");
    window.clientConfig.isWeb && document.body.classList.add("web");
    window.clientConfig.isWebview && document.body.classList.add("webview");
    document.body.classList.add(`app-lang--${window.clientConfig.lang}`);

    clientStorage.incrementTabOpenAmount();

    document.body.addEventListener("mousewheel", (e) => {
      // отключаем скейлинг страницы по ctrl+scroll
      if (e.ctrlKey) {
        e.preventDefault();
      }
    }, {passive: false});

    if (window.clientConfig.isWeb) {
      calculateViewport();
      window.addEventListener("resize", calculateViewport);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", calculateViewport);
  }

  handleWebviewTabSelected = () => {

  };

  handleRouteChanged = () => {
    window.scrollTo(0, 0);
  };

  checkAwaitingBilledSku = (purchases) => {
    const awaitingBilledSku = clientStorage.getAwaitingBilledSku();
    if (awaitingBilledSku !== undefined) {
      const hasAwaitingSku = purchases.find((purchase) => {
        return purchase.product_id === awaitingBilledSku && purchase.available > 0;
      });

      if (hasAwaitingSku || window.clientConfig.subscriptionSku === awaitingBilledSku) {
        hitEvent(hits.PURCHASE_VISIT);
        logEvent(userEvents.PURCHASE_VISIT);
        clientStorage.clearAwaitingBilledSku();
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        <RouteChangeListener onChanged={this.handleRouteChanged} />
        <WindowSizeWatcher />
        <AppToast {...this.context.toast} />
        <ErrorBoundary>
          {this.state.isReady && <Switch>
            <Route exact path={routes.INDEX} render={(props) => <IndexPage {...props} />} />
            <Route exact path={routes.PROCESSING} render={(props) => <ProcessingPage {...props} />} />
            <Route exact path={routes.RESULT} render={(props) => <ResultPage {...props} />} />
            <Route exact path={routes.PHOTOCHOOSER} render={(props) => <PhotochooserPage {...props} />} />
            <Route exact path={"/comparator"} render={(props) => <ComparatorPage {...props} />} />
          </Switch>}
          <ModalWrapper />
        </ErrorBoundary>
        <TestInstanceIndicator />
      </React.Fragment>
    );
  }
}

App.contextType = AppContext;

const AppWithRouter = withRouter(App);

ReactDOM.createRoot(document.getElementById("root")).render(
  <AppContextProvider>
    <BrowserRouter>
      <AppWithRouter />
    </BrowserRouter>
  </AppContextProvider>
);